const bidSlotExpiryDefault = 7200000;

const PtlTransitDelayMode = {
  Percentage: 1,
  Days: 2,
};
const slaType = {
  ARRIVAL_CUTOFF: 1,
  INDENT_CUTOFF: 2,
  INDENT_AUTO_CANCEL: 3,
  ACCEPTANCE_SLA: 4,
  DEPOT_WORKING_TIME_SLA: 5,
  REINDENT_ACCEPTANCE_SLA: 6,
  REINDENT_ARRIVAL_CUTOFF: 7,
};

const OrderSlaTriggerJobType = {
  ARRIVAL: 'ARRIVAL',
  ACCEPTANCE: 'ACCEPTANCE',
};

const purchaseOrderTypeInLr = {
  DEFAULT: 1,
  MATERIAL_LEVEL: 2,
};

const defaultIndentCutOff = 12 * 60 * 60 * 1000; // indent creation cutoff time
const defaultArrivalCutOff = (17 + 0.5) * 60 * 60 * 1000;

const dieselPegThresholdType = {
  PERCENTAGE: 1,
  ABSOLUTE_VALUE: 2,
};

const TransitDelayFactor = {
  PERCENTAGE: 1,
  ABSOLUTE: 2,
};

const defaultPasswordHistorySize = 3;

const invalidPincodeData = {
  latitude : '20.593684',
  longitude:'78.96288',
  googlePlaceId:'ChIJkbeSa_BfYzARphNChaFPjNc',
};
const defaultlatLong = [{"formattedAddress":"CIT Nagar, Tamil Nadu 606401, India",  
          "latitude":13.0311048214734,
          "longitude":80.22954095825037,
          "extra":{"googlePlaceId":"ChIJ8ZmeO1qDrDsRZwmrzTqp6zw",
          "confidence":0.5,
          "premise":null,
          "subpremise":null,
          "neighborhood":"T.Nagar",
          "establishment":null},
          "administrativeLevels":{"level1long":"Tamil Nadu","level1short":"TN"},
          "zipcode":"606401",
          "city":"T.Nagar",
          "country":"India","countryCode":"IN",
          "provider":"google"}];

module.exports = {
  bidSlotExpiryDefault,
  PtlTransitDelayMode,
  slaType,
  defaultIndentCutOff,
  defaultArrivalCutOff,
  OrderSlaTriggerJobType,
  purchaseOrderTypeInLr,
  dieselPegThresholdType,
  TransitDelayFactor,
  invalidPincodeData,
  defaultlatLong,
  defaultPasswordHistorySize
};
